/* eslint-disable @next/next/no-img-element */
import React, { useCallback } from 'react';
import Head from 'next/head';
import useEmblaCarousel from 'embla-carousel-react';
import Styles from './BlogPostsRecentes.css';

function BlogPostsRecentes({ posts, ...props }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    direction: 'lrf',
    align: 0,
    containScroll: 'trimSnaps',
  });

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <>
      <Head>
        {/* <script
          async
          custom-element="amp-carousel"
          src="https://cdn.ampproject.org/v0/amp-carousel-0.2.js"
        /> */}
      </Head>
      <article {...props} className={`blog-recent ${props.className}`}>
        <h2>Publicações recentes</h2>

        <div className="embla">
          <div className="embla__viewport" ref={emblaRef}>
            <div className="embla__container">
              {posts.map((p, i) => {
                return (
                  <div className="embla__slide" key={`post-item-${i}`}>
                    <a
                      className="recent-post"
                      href={`${p.slug}${process.env.NODE_ENV === 'production' ? '.html' : ''}`}
                      id={p.seo?.relatedLinkId}
                    >
                      <div>
                        <h3 dangerouslySetInnerHTML={{ __html: `${p.thumbnailText}` }} />
                        <img
                          alt={p.thumbnailAlt}
                          src={p.thumbnailSrc}
                          height="229"
                          width="263.71"
                        />
                      </div>
                    </a>
                  </div>
                );
              })}
            </div>
            <button className="embla__prev" onClick={scrollPrev} />
            <button className="embla__next" onClick={scrollNext} />
          </div>
        </div>
      </article>
      <style jsx>{Styles}</style>
    </>
  );
}

export default BlogPostsRecentes;
